'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('./_rollupPluginBabelHelpers-b2d9610a.js');
var React = require('react');
var index = require('./index-fccd5f88.js');
var Containers = require('./Containers-776a4de4.js');
var Form = require('./Form-0d520604.js');
var Fieldset = require('./Fieldset-a726f6aa.js');
var Radio = require('./Radio-0d5d99e0.js');
var DatePicker = require('./DatePicker-a504241d.js');
var Select = require('./Select-eaf90214.js');
var selectOption = require('./selectOption-feb5f417.js');
var Button = require('./Button-ef2d53dd.js');
var Typography = require('./Typography-8468e4cf.js');
require('./Image-45b5324e.js');
var DestAutoComplete = require('./DestAutoComplete-6344ad8f.js');
var Grid = require('./Grid-2bf1e317.js');
var injectGlobalCss = require('./injectGlobalCss-bc8cf911.js');
var Input = require('./Input-3165014f.js');
var SubTabs = require('./SubTabs-d83b2fc5.js');
require('./index.esm-c1e26669.js');
require('./index-72f7f45d.js');
require('./Tooltip-db0e2164.js');
require('react-dom');
require('./Icons-46f5553f.js');
require('./Loader-ba47a627.js');
require('./blur-ef853b38.js');
require('./Image.module-e3b7ba64.js');
require('./Autocomplete-dbb3d852.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var css$4 = ".HotelSearch_module_visuallyHidden__3cdc2b35 {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n.HotelSearch_module_youtubeVideo__3cdc2b35 {\n  width: 100%;\n  height: auto;\n  aspect-ratio: 16/9;\n  display: block;\n}\n\n.HotelSearch_module_Form__3cdc2b35 {\n  display: flex;\n  align-items: flex-start;\n  flex-wrap: wrap;\n}\n\n.HotelSearch_module_Radios__3cdc2b35 {\n  width: 100%;\n  margin-right: 24px;\n}\n\n.HotelSearch_module_destSearchInput__3cdc2b35 {\n  width: 100%;\n  min-width: 100%;\n  max-width: none;\n}\n.HotelSearch_module_destSearchInput__3cdc2b35 > div {\n  max-width: none;\n}\n.HotelSearch_module_destSearchInput__3cdc2b35 input {\n  z-index: 0;\n}\n.HotelSearch_module_destSearchInput__3cdc2b35:focus-within {\n  z-index: 99;\n}\n\n.HotelSearch_module_SubmitBtn__3cdc2b35 {\n  height: 88px;\n  min-width: 200px;\n}\n\n.HotelSearch_module_DateAndTime__3cdc2b35 {\n  display: flex;\n  gap: 24px;\n}\n.HotelSearch_module_DateAndTime__3cdc2b35 .HotelSearch_module_Date__3cdc2b35, .HotelSearch_module_DateAndTime__3cdc2b35 .HotelSearch_module_ReturnDateHolder__3cdc2b35 {\n  width: 50%;\n  max-width: none;\n}\n.HotelSearch_module_DateAndTime__3cdc2b35 .HotelSearch_module_Date__3cdc2b35 *, .HotelSearch_module_DateAndTime__3cdc2b35 .HotelSearch_module_ReturnDateHolder__3cdc2b35 * {\n  min-width: none;\n}\n\n@media (min-width: 768px) {\n  .HotelSearch_module_airhotel__3cdc2b35 {\n    grid-column-start: 1;\n    grid-column-end: 5;\n  }\n}";
injectGlobalCss.injectCss(css$4, "/opt/atlassian/pipelines/agent/build/src/stories/components/AAA/BookingWidget/Hotel/HotelSearch.module.scss");
var modules_3b322da3 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1080px)","uiBreakWideScreenMin":"strip-units(1920px)","visuallyHidden":"HotelSearch_module_visuallyHidden__3cdc2b35","youtubeVideo":"HotelSearch_module_youtubeVideo__3cdc2b35","Form":"HotelSearch_module_Form__3cdc2b35","Radios":"HotelSearch_module_Radios__3cdc2b35","destSearchInput":"HotelSearch_module_destSearchInput__3cdc2b35","SubmitBtn":"HotelSearch_module_SubmitBtn__3cdc2b35","DateAndTime":"HotelSearch_module_DateAndTime__3cdc2b35","Date":"HotelSearch_module_Date__3cdc2b35","ReturnDateHolder":"HotelSearch_module_ReturnDateHolder__3cdc2b35","airhotel":"HotelSearch_module_airhotel__3cdc2b35"};

var acceptedExtraParameters = ["book", "propid", "appid", "xbrand", "xchain", "xpropname", "xdiamond", "xadid", "xadtype", "xadsize", "PropID", "Utm_Campaign", "Utm_Medium", "Utm_Source", "Utm_ID", "UTM_Club", "EID_Campaign"];
function getAcceptedExtraQueryParameters() {
  if (typeof window === "undefined") return {};
  if (window.location == null) return {};
  if (window.location.search == null) return {};
  try {
    var pairs = window.location.search.substring(1).split("&");
    var obj = {};
    var pair;
    var i;
    for (i in pairs) {
      // Make sure the field is not blank
      if (pairs[i].trim() === "") continue;
      pair = pairs[i].split("=");

      // Make sure we only have 2 values
      if (pair.length != 2) continue;
      var key = decodeURIComponent(pair[0]);
      var value = decodeURIComponent(pair[1]);

      // make sure the parameter is accepted
      // convert both to lowercase before comparison
      if (!acceptedExtraParameters.map(function (x) {
        return x.toLowerCase();
      }).includes(key.toLowerCase())) continue;

      // Add a new key to the object
      obj[key] = value;
    }
    return obj;
  } catch (e) {
    console.log("An error occured getting url parameters");
    console.log(e);
    return {};
  }
}
function BookingWidgetExtraParameters() {
  var bookTravelExtraParameters = getAcceptedExtraQueryParameters();
  return /*#__PURE__*/React__default["default"].createElement("div", null, Object.keys(bookTravelExtraParameters).map(function (x) {
    return /*#__PURE__*/React__default["default"].createElement("input", {
      key: "booking-widget-extra-parameter-" + x,
      type: "hidden",
      name: x,
      value: bookTravelExtraParameters[x]
    });
  }));
}

function HotelSearch(_ref) {
  var clubCode = _ref.clubCode,
    hotelSearchAction = _ref.hotelSearchAction,
    chainCode = _ref.chainCode;
  var _useState = React.useState("hotel"),
    _useState2 = _rollupPluginBabelHelpers._slicedToArray(_useState, 2),
    formState = _useState2[0],
    setFormState = _useState2[1];
  React.useEffect(function () {
    setFormState();
  }, []);
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(Grid.GridContainer, {
    width: "980",
    noPadding: true
  }, /*#__PURE__*/React__default["default"].createElement(Grid.GridColumn, {
    columnS: "12"
  }, /*#__PURE__*/React__default["default"].createElement(Typography.Header2, {
    serif: true,
    bold: true,
    centerText: true
  }, "AAA Hotel Search")), /*#__PURE__*/React__default["default"].createElement(Grid.GridColumn, {
    columnS: "12"
  }, /*#__PURE__*/React__default["default"].createElement(Form.Form, {
    extraClass: modules_3b322da3.Form,
    formAction: "https://www.aaa.com/sharedservices/booktravel.jsp?"
  }, /*#__PURE__*/React__default["default"].createElement("input", {
    type: "hidden",
    name: "book",
    value: "hotel"
  }), clubCode != null && clubCode.trim().length > 0 ? /*#__PURE__*/React__default["default"].createElement("input", {
    type: "hidden",
    name: "club",
    value: clubCode
  }) : /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null), /*#__PURE__*/React__default["default"].createElement(BookingWidgetExtraParameters, null), chainCode != null && chainCode.trim().length > 0 ? /*#__PURE__*/React__default["default"].createElement("input", {
    type: "hidden",
    name: "chaincode",
    value: chainCode
  }) : /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null), /*#__PURE__*/React__default["default"].createElement(Grid.GridContainer, {
    width: "980",
    gap: "noRowGap"
  }, formState == "airhotel" ? /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(Grid.GridColumn, {
    columnS: "6",
    columnM: "4"
  }, /*#__PURE__*/React__default["default"].createElement(DestAutoComplete.DestAutoComplete, {
    id: "hotelFromPackageLocationInput",
    inputName: "depart",
    label: "Enter Origin",
    placeholder: "Enter Origin",
    airports: true,
    extraClass: modules_3b322da3.destSearchInput
  })), /*#__PURE__*/React__default["default"].createElement(Grid.GridColumn, {
    columnS: "6",
    columnM: "4"
  }, /*#__PURE__*/React__default["default"].createElement(DestAutoComplete.DestAutoComplete, {
    id: "hotelFromLocationInput2",
    inputName: "arrive",
    label: "Enter Destination",
    placeholder: "Enter Destination",
    airports: true,
    extraClass: modules_3b322da3.destSearchInput
  }))) : /*#__PURE__*/React__default["default"].createElement(Grid.GridColumn, {
    columnS: "6",
    columnM: "4"
  }, /*#__PURE__*/React__default["default"].createElement(DestAutoComplete.DestAutoComplete, {
    id: "hotelFromLocationInput",
    inputName: "location",
    label: "Enter Destination",
    placeholder: "Enter Destination",
    extraClass: modules_3b322da3.destSearchInput
  })), /*#__PURE__*/React__default["default"].createElement(Grid.GridColumn, {
    columnS: "6",
    columnM: formState == "airhotel" ? "6" : "6"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_3b322da3.DateAndTime
  }, /*#__PURE__*/React__default["default"].createElement(DatePicker.DatePicker, {
    extraClass: modules_3b322da3.Date,
    inputID: "bwHotelCheckin",
    inputName: "checkin",
    label: formState == "airhotel" ? "Depart" : "Check in"
  }), /*#__PURE__*/React__default["default"].createElement(DatePicker.DatePicker, {
    extraClass: modules_3b322da3.Date,
    inputID: "bwHotelCheckout",
    inputName: "checkout",
    label: formState == "airhotel" ? "Return" : "Check Out",
    plusDays: 2
  }))), /*#__PURE__*/React__default["default"].createElement(Grid.GridColumn, {
    columnS: "6"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_3b322da3.DateAndTime
  }, /*#__PURE__*/React__default["default"].createElement(Select.Select, {
    extraClass: modules_3b322da3.Select,
    id: "hotelRoomsSelect",
    label: "Rooms",
    name: "rooms"
  }, /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "1",
    value: "1"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "2",
    value: "2"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "3",
    value: "3"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "4",
    value: "4"
  })), /*#__PURE__*/React__default["default"].createElement(Select.Select, {
    extraClass: modules_3b322da3.Select,
    id: "hotelAdultsSelect",
    label: "Adults",
    name: "adults"
  }, /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "1",
    value: "1"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "2",
    value: "2"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "3",
    value: "3"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "4",
    value: "4"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "5",
    value: "5"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "6",
    value: "6"
  })), /*#__PURE__*/React__default["default"].createElement(Select.Select, {
    extraClass: modules_3b322da3.Select,
    id: "hotelChildrenSelect",
    label: "Children",
    name: "children"
  }, /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "0",
    value: "0"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "1",
    value: "1"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "2",
    value: "2"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "3",
    value: "3"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "4",
    value: "4"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "5",
    value: "5"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "6",
    value: "6"
  })))), /*#__PURE__*/React__default["default"].createElement(Grid.GridColumn, {
    columnM: "12",
    alignHorizontal: "center",
    alignVertical: "bottom"
  }, /*#__PURE__*/React__default["default"].createElement(Button.Button, {
    extraClass: modules_3b322da3.SubmitBtn,
    label: "Search Hotels",
    style: "NEU_PRIMARY",
    type: "button",
    ariaLabel: "",
    action: function action(e) {
      // If we have a hotel search action
      if (hotelSearchAction) {
        // Try to resolve the result of the hotelSearchAction as a promise
        // If it's a promise, it'll wait
        // otherwise, it'll execute immediately
        // https://stackoverflow.com/questions/27746304/how-to-check-if-an-object-is-a-promise
        Promise.resolve(hotelSearchAction(e)).then(function () {
          // Make sure we have valid values and submit our form
          if (e && e.target && e.target.closest("form")) {
            e.target.closest("form").submit();
          }
        });
      } else {
        // Make sure we have valid values and submit our form
        if (e && e.target && e.target.closest("form")) {
          e.target.closest("form").submit();
        }
      }
    }
  })))))));
}
HotelSearch.propTypes = {
  hotelSearchAction: index.propTypes.exports.func,
  chainCode: index.propTypes.exports.string,
  clubCode: index.propTypes.exports.string
};

var css$3 = ".CarSearch_module_visuallyHidden__3907ab1b {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n.CarSearch_module_youtubeVideo__3907ab1b {\n  width: 100%;\n  height: auto;\n  aspect-ratio: 16/9;\n  display: block;\n}\n\n.CarSearch_module_Radios__3907ab1b {\n  width: 100%;\n  margin-right: 24px;\n}\n@media (max-width: 450px) {\n  .CarSearch_module_Radios__3907ab1b {\n    align-items: flex-start;\n  }\n}\n\n.CarSearch_module_Radio__3907ab1b {\n  min-width: 178px;\n  margin-right: 0;\n}\n@media (max-width: 450px) {\n  .CarSearch_module_Radio__3907ab1b {\n    width: 50%;\n    min-width: auto;\n  }\n}\n.CarSearch_module_Radio__3907ab1b.CarSearch_module_RadioLast__3907ab1b {\n  margin-right: 0;\n}\n\n.CarSearch_module_DateAndTime__3907ab1b {\n  display: flex;\n  gap: 24px;\n}\n.CarSearch_module_DateAndTime__3907ab1b .CarSearch_module_Date__3907ab1b {\n  width: 50%;\n  max-width: none;\n}\n.CarSearch_module_DateAndTime__3907ab1b .CarSearch_module_Date__3907ab1b * {\n  min-width: none;\n}\n\n.CarSearch_module_Input__3907ab1b {\n  min-width: auto;\n  max-width: 320px;\n  margin-right: 24px;\n}\n@media (max-width: 500px) {\n  .CarSearch_module_Input__3907ab1b {\n    min-width: auto;\n    width: 100%;\n    max-width: none;\n  }\n}\n\n.CarSearch_module_destinationSearchInput__3907ab1b {\n  width: 100%;\n  min-width: 100%;\n  max-width: none;\n}\n.CarSearch_module_destinationSearchInput__3907ab1b > div {\n  max-width: none;\n}\n.CarSearch_module_destinationSearchInput__3907ab1b input {\n  z-index: 0;\n}\n.CarSearch_module_destinationSearchInput__3907ab1b:focus-within {\n  z-index: 99;\n}\n\n.CarSearch_module_SubmitBtn__3907ab1b {\n  height: 88px;\n  min-width: 200px;\n}\n\n.CarSearch_module_carInputFields__3907ab1b {\n  max-width: none;\n}\n.CarSearch_module_carInputFields__3907ab1b > div {\n  max-width: none;\n}\n\n@media only screen and (min-width: 1024px) {\n  .CarSearch_module_diffLocationColOffset__3907ab1b {\n    grid-column-start: 1 !important;\n    grid-column-end: 5 !important;\n  }\n}";
injectGlobalCss.injectCss(css$3, "/opt/atlassian/pipelines/agent/build/src/stories/components/AAA/BookingWidget/Car/CarSearch.module.scss");
var modules_8f371644 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1080px)","uiBreakWideScreenMin":"strip-units(1920px)","visuallyHidden":"CarSearch_module_visuallyHidden__3907ab1b","youtubeVideo":"CarSearch_module_youtubeVideo__3907ab1b","Radios":"CarSearch_module_Radios__3907ab1b","Radio":"CarSearch_module_Radio__3907ab1b","RadioLast":"CarSearch_module_RadioLast__3907ab1b","DateAndTime":"CarSearch_module_DateAndTime__3907ab1b","Date":"CarSearch_module_Date__3907ab1b","Input":"CarSearch_module_Input__3907ab1b","destinationSearchInput":"CarSearch_module_destinationSearchInput__3907ab1b","SubmitBtn":"CarSearch_module_SubmitBtn__3907ab1b","carInputFields":"CarSearch_module_carInputFields__3907ab1b","diffLocationColOffset":"CarSearch_module_diffLocationColOffset__3907ab1b"};

var CarSearch = function CarSearch(_ref) {
  var chainCode = _ref.chainCode,
    clubCode = _ref.clubCode,
    carSearchAction = _ref.carSearchAction,
    preFillCarInputPromoNumber = _ref.preFillCarInputPromoNumber;
  var _useState = React.useState(),
    _useState2 = _rollupPluginBabelHelpers._slicedToArray(_useState, 2),
    formState = _useState2[0],
    setFormState = _useState2[1];
  var radioHandle = function radioHandle(e) {
    var radioValue = e.target.value;
    setFormState(radioValue);
  };
  React.useEffect(function () {
    setFormState();
  }, []);
  return /*#__PURE__*/React__default["default"].createElement(Grid.GridContainer, {
    width: "1440"
  }, /*#__PURE__*/React__default["default"].createElement(Grid.GridColumn, null, /*#__PURE__*/React__default["default"].createElement(Typography.Header2, {
    serif: true,
    bold: true,
    centerText: true
  }, "AAA Rental Car Search")), /*#__PURE__*/React__default["default"].createElement(Grid.GridColumn, null, /*#__PURE__*/React__default["default"].createElement(Form.Form, {
    formAction: "https://www.aaa.com/sharedservices/booktravel.jsp?"
  }, /*#__PURE__*/React__default["default"].createElement(BookingWidgetExtraParameters, null), /*#__PURE__*/React__default["default"].createElement("input", {
    type: "hidden",
    name: "book",
    value: "car"
  }), clubCode != null && clubCode.trim().length > 0 ? /*#__PURE__*/React__default["default"].createElement("input", {
    type: "hidden",
    name: "club",
    value: clubCode
  }) : /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null), chainCode != null && chainCode.trim().length > 0 ? /*#__PURE__*/React__default["default"].createElement("input", {
    type: "hidden",
    name: "chaincode",
    value: chainCode
  }) : /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null), /*#__PURE__*/React__default["default"].createElement(Grid.GridContainer, {
    width: "980",
    gap: "noRowGap"
  }, /*#__PURE__*/React__default["default"].createElement(Grid.GridColumn, {
    columnM: formState == "diffLocation" ? "12" : "12"
  }, /*#__PURE__*/React__default["default"].createElement(Fieldset.Fieldset, {
    extraClass: modules_8f371644.Radios,
    legend: "Choose Pick Up and Drop Off Location"
  }, /*#__PURE__*/React__default["default"].createElement(Radio.Radio, {
    extraClass: modules_8f371644.Radio,
    id: "samLocCar",
    name: "carRadios",
    value: "sameLocation",
    label: "Same location",
    checked: true,
    onChange: radioHandle
  }), /*#__PURE__*/React__default["default"].createElement(Radio.Radio, {
    extraClass: [modules_8f371644.Radio, modules_8f371644.RadioLast].join(" "),
    id: "diffLocCar",
    name: "carRadios",
    value: "diffLocation",
    label: "Different location",
    onChange: radioHandle
  }))), /*#__PURE__*/React__default["default"].createElement(Grid.GridColumn, {
    columnS: "6",
    columnM: "4"
  }, /*#__PURE__*/React__default["default"].createElement(DestAutoComplete.DestAutoComplete, {
    id: "carFromInputLocation",
    inputName: "location",
    label: "Pick up location",
    placeholder: "Pick up location",
    extraClass: modules_8f371644.destinationSearchInput
  })), /*#__PURE__*/React__default["default"].createElement(Grid.GridColumn, {
    columnS: "6",
    columnM: "4"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_8f371644.DateAndTime
  }, /*#__PURE__*/React__default["default"].createElement(DatePicker.DatePicker, {
    extraClass: modules_8f371644.Date,
    inputID: "bwCarCheckin",
    inputName: "pickupdate",
    label: "Pick up date"
  }), /*#__PURE__*/React__default["default"].createElement(Select.Select, {
    extraClass: modules_8f371644.Select,
    id: "pickUpTimeSelect",
    label: "Pick up time",
    name: "pickuptime",
    defaultValue: "10:00am"
  }, /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "12:00am",
    name: "12:00am"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "1:00am",
    name: "1:00am"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "2:00am",
    name: "2:00am"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "3:00am",
    name: "3:00am"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "4:00am",
    name: "4:00am"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "5:00am",
    name: "5:00am"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "6:00am",
    name: "6:00am"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "7:00am",
    name: "7:00am"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "8:00am",
    name: "8:00am"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "9:00am",
    name: "9:00am"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "10:00am",
    name: "10:00am"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "11:00am",
    name: "11:00am"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "1:00pm",
    name: "1:00pm"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "2:00pm",
    name: "2:00pm"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "3:00pm",
    name: "3:00pm"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "4:00pm",
    name: "4:00pm"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "5:00pm",
    name: "5:00pm"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "6:00pm",
    name: "6:00pm"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "7:00pm",
    name: "7:00pm"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "8:00pm",
    name: "8:00pm"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "9:00pm",
    name: "9:00pm"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "10:00pm",
    name: "10:00pm"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "11:00pm",
    name: "11:00pm"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "12:00pm",
    name: "12:00pm"
  })))), formState == "diffLocation" ? /*#__PURE__*/React__default["default"].createElement(Grid.GridColumn, {
    extraClass: modules_8f371644.diffLocationColOffset,
    columnS: "6",
    columnM: "4"
  }, /*#__PURE__*/React__default["default"].createElement(DestAutoComplete.DestAutoComplete, {
    id: "carDropInputLocation",
    inputName: "dolocationname",
    label: "Drop off location",
    placeholder: "Drop off location",
    extraClass: modules_8f371644.destinationSearchInput,
    cars: true
  })) : null, /*#__PURE__*/React__default["default"].createElement(Grid.GridColumn, {
    columnS: "6",
    columnM: "4"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_8f371644.DateAndTime
  }, /*#__PURE__*/React__default["default"].createElement(DatePicker.DatePicker, {
    extraClass: modules_8f371644.Date,
    inputID: "bwCarCheckout",
    inputName: "dropoffdate",
    label: "Drop off date",
    plusDays: 2
  }), /*#__PURE__*/React__default["default"].createElement(Select.Select, {
    extraClass: modules_8f371644.Select,
    id: "dropOffTimeSelect",
    label: "Drop off time",
    name: "dropofftime",
    defaultValue: "10:00am"
  }, /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "12:00am",
    name: "12:00am"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "1:00am",
    name: "1:00am"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "2:00am",
    name: "2:00am"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "3:00am",
    name: "3:00am"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "4:00am",
    name: "4:00am"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "5:00am",
    name: "5:00am"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "6:00am",
    name: "6:00am"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "7:00am",
    name: "7:00am"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "8:00am",
    name: "8:00am"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "9:00am",
    name: "9:00am"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "10:00am",
    name: "10:00am"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "11:00am",
    name: "11:00am"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "1:00pm",
    name: "1:00pm"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "2:00pm",
    name: "2:00pm"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "3:00pm",
    name: "3:00pm"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "4:00pm",
    name: "4:00pm"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "5:00pm",
    name: "5:00pm"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "6:00pm",
    name: "6:00pm"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "7:00pm",
    name: "7:00pm"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "8:00pm",
    name: "8:00pm"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "9:00pm",
    name: "9:00pm"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "10:00pm",
    name: "10:00pm"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "11:00pm",
    name: "11:00pm"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    value: "12:00pm",
    name: "12:00pm"
  })))), /*#__PURE__*/React__default["default"].createElement(Grid.GridColumn, {
    extraClass: formState == "diffLocation" ? modules_8f371644.diffLocationColOffset : null,
    columnS: "6",
    columnM: "4"
  }, /*#__PURE__*/React__default["default"].createElement(Input.Input, {
    id: "discountpp",
    name: "discountpp",
    placeholder: "Hertz Gold Plus Rewards",
    label: "Hertz Gold Plus Rewards",
    autocompleteoff: true,
    extraClass: modules_8f371644.carInputFields,
    type: "text"
    // hideLabel
  })), /*#__PURE__*/React__default["default"].createElement(Grid.GridColumn, {
    columnS: "6",
    columnM: "4"
  }, /*#__PURE__*/React__default["default"].createElement(Input.Input, {
    id: "couponnumber",
    name: "couponnumber",
    placeholder: "Promo Coupon Number",
    label: "Promo Coupon Number",
    defaultValue: preFillCarInputPromoNumber,
    autocompleteoff: true,
    extraClass: modules_8f371644.carInputFields,
    type: "text"
  })), /*#__PURE__*/React__default["default"].createElement(Grid.GridColumn, {
    columnS: "6",
    columnM: "4"
  }, /*#__PURE__*/React__default["default"].createElement(Input.Input, {
    id: "ratecode",
    name: "ratecode",
    placeholder: "Rate Code Number",
    label: "Rate Code Number",
    autocompleteoff: true,
    extraClass: modules_8f371644.carInputFields,
    type: "text"
  })), /*#__PURE__*/React__default["default"].createElement(Grid.GridColumn, {
    alignHorizontal: "center"
  }, /*#__PURE__*/React__default["default"].createElement(Button.Button, {
    extraClass: modules_8f371644.SubmitBtn,
    label: "Search Cars",
    style: "NEU_PRIMARY",
    type: "button",
    ariaLabel: "",
    action: function action(e) {
      // If we have a car search action
      if (carSearchAction) {
        // Try to resolve the result of the carSearchAction as a promise
        // If it's a promise, it'll wait
        // otherwise, it'll execute immediately
        // https://stackoverflow.com/questions/27746304/how-to-check-if-an-object-is-a-promise
        Promise.resolve(carSearchAction(e)).then(function () {
          // Make sure we have valid values and submit our form
          if (e && e.target && e.target.closest("form")) {
            e.target.closest("form").submit();
          }
        });
      } else {
        // Make sure we have valid values and submit our form
        if (e && e.target && e.target.closest("form")) {
          e.target.closest("form").submit();
        }
      }
    }
  }))))));
};
var CarSearchPropTypes = {
  clubCode: index.propTypes.exports.string,
  chainCode: index.propTypes.exports.string,
  carSearchAction: index.propTypes.exports.func,
  preFillCarInputPromoNumber: index.propTypes.exports.string
};
CarSearch.propTypes = CarSearchPropTypes;

var css$2 = ".FlightSearch_module_visuallyHidden__faaee37d {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n.FlightSearch_module_youtubeVideo__faaee37d {\n  width: 100%;\n  height: auto;\n  aspect-ratio: 16/9;\n  display: block;\n}\n\n.FlightSearch_module_Form__faaee37d {\n  display: flex;\n  align-items: flex-start;\n  flex-wrap: wrap;\n}\n\n.FlightSearch_module_Radios__faaee37d {\n  min-width: 310px;\n  margin-right: 24px;\n}\n\n.FlightSearch_module_Radio__faaee37d {\n  min-width: 142px;\n}\n\n.FlightSearch_module_destSearchInput__faaee37d {\n  width: 100%;\n  min-width: 100%;\n  max-width: none;\n}\n.FlightSearch_module_destSearchInput__faaee37d > div {\n  max-width: none;\n}\n.FlightSearch_module_destSearchInput__faaee37d input {\n  z-index: 0;\n}\n.FlightSearch_module_destSearchInput__faaee37d:focus-within {\n  z-index: 99;\n}\n\n.FlightSearch_module_passengers__faaee37d {\n  display: flex;\n  gap: 24px;\n}\n.FlightSearch_module_passengers__faaee37d .FlightSearch_module_Select__faaee37d {\n  width: 50%;\n  margin-right: 0;\n}\n\n.FlightSearch_module_Origin__faaee37d {\n  z-index: 4;\n}\n\n.FlightSearch_module_DateAndTime__faaee37d {\n  display: flex;\n  gap: 24px;\n}\n.FlightSearch_module_DateAndTime__faaee37d .FlightSearch_module_Date__faaee37d, .FlightSearch_module_DateAndTime__faaee37d .FlightSearch_module_ReturnDateHolder__faaee37d {\n  width: 50%;\n  max-width: none;\n}\n.FlightSearch_module_DateAndTime__faaee37d .FlightSearch_module_Date__faaee37d *, .FlightSearch_module_DateAndTime__faaee37d .FlightSearch_module_ReturnDateHolder__faaee37d * {\n  min-width: none;\n}\n\n.FlightSearch_module_SelectAuto__faaee37d {\n  margin-right: 24px;\n}\n\n.FlightSearch_module_SubmitBtn__faaee37d {\n  height: 88px;\n  min-width: 200px;\n  margin-top: 0;\n}";
injectGlobalCss.injectCss(css$2, "/opt/atlassian/pipelines/agent/build/src/stories/components/AAA/BookingWidget/Flight/FlightSearch.module.scss");
var modules_c6e28c37 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1080px)","uiBreakWideScreenMin":"strip-units(1920px)","visuallyHidden":"FlightSearch_module_visuallyHidden__faaee37d","youtubeVideo":"FlightSearch_module_youtubeVideo__faaee37d","Form":"FlightSearch_module_Form__faaee37d","Radios":"FlightSearch_module_Radios__faaee37d","Radio":"FlightSearch_module_Radio__faaee37d","destSearchInput":"FlightSearch_module_destSearchInput__faaee37d","passengers":"FlightSearch_module_passengers__faaee37d","Select":"FlightSearch_module_Select__faaee37d","Origin":"FlightSearch_module_Origin__faaee37d","DateAndTime":"FlightSearch_module_DateAndTime__faaee37d","Date":"FlightSearch_module_Date__faaee37d","ReturnDateHolder":"FlightSearch_module_ReturnDateHolder__faaee37d","SelectAuto":"FlightSearch_module_SelectAuto__faaee37d","SubmitBtn":"FlightSearch_module_SubmitBtn__faaee37d"};

var FlightSearch = function FlightSearch(_ref) {
  var flightSearchAction = _ref.flightSearchAction,
    chainCode = _ref.chainCode,
    clubCode = _ref.clubCode;
  var _useState = React.useState(),
    _useState2 = _rollupPluginBabelHelpers._slicedToArray(_useState, 2),
    formState = _useState2[0],
    setFormState = _useState2[1];
  var radioHandle = function radioHandle(e) {
    var radioValue = e.target.value;
    setFormState(radioValue);
  };
  React.useEffect(function () {
    setFormState();
  }, []);
  return /*#__PURE__*/React__default["default"].createElement(Grid.GridContainer, {
    width: "1440"
  }, /*#__PURE__*/React__default["default"].createElement(Grid.GridColumn, {
    columnS: "12"
  }, /*#__PURE__*/React__default["default"].createElement(Typography.Header2, {
    serif: true,
    bold: true,
    centerText: true
  }, "AAA Flight Search")), /*#__PURE__*/React__default["default"].createElement(Grid.GridColumn, {
    columnS: "12"
  }, /*#__PURE__*/React__default["default"].createElement(Form.Form, {
    extraClass: modules_c6e28c37.Form,
    formAction: "https://www.aaa.com/sharedservices/booktravel.jsp?"
  }, /*#__PURE__*/React__default["default"].createElement(BookingWidgetExtraParameters, null), /*#__PURE__*/React__default["default"].createElement("input", {
    type: "hidden",
    name: "book",
    value: "air"
  }), clubCode != null && clubCode.trim().length > 0 ? /*#__PURE__*/React__default["default"].createElement("input", {
    type: "hidden",
    name: "club",
    value: clubCode
  }) : /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null), chainCode != null && chainCode.trim().length > 0 ? /*#__PURE__*/React__default["default"].createElement("input", {
    type: "hidden",
    name: "chaincode",
    value: chainCode
  }) : /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null), /*#__PURE__*/React__default["default"].createElement(Grid.GridContainer, {
    width: "980",
    gap: "noRowGap"
  }, /*#__PURE__*/React__default["default"].createElement(Grid.GridColumn, {
    columnM: "4"
  }, /*#__PURE__*/React__default["default"].createElement(Fieldset.Fieldset, {
    extraClass: modules_c6e28c37.Radios,
    legend: "Flight Search"
  }, /*#__PURE__*/React__default["default"].createElement(Radio.Radio, {
    extraClass: modules_c6e28c37.Radio,
    id: "roundTripFLight",
    name: "st",
    value: "roundtrip",
    label: "Round trip",
    checked: true,
    onChange: radioHandle
  }), /*#__PURE__*/React__default["default"].createElement(Radio.Radio, {
    extraClass: modules_c6e28c37.Radio,
    id: "oneWayFlight",
    name: "st",
    value: "oneway",
    label: "One way",
    onChange: radioHandle
  }))), /*#__PURE__*/React__default["default"].createElement(Grid.GridColumn, {
    columnS: "6",
    columnM: "4"
  }, /*#__PURE__*/React__default["default"].createElement(DestAutoComplete.DestAutoComplete, {
    id: "flightInputFrom",
    inputName: "depart",
    label: "Enter Origin",
    placeholder: "Enter Origin",
    useResponseValues: true,
    filterMismatchingValues: true,
    airports: true,
    extraClass: modules_c6e28c37.destSearchInput
  })), /*#__PURE__*/React__default["default"].createElement(Grid.GridColumn, {
    columnS: "6",
    columnM: "4"
  }, /*#__PURE__*/React__default["default"].createElement(DestAutoComplete.DestAutoComplete, {
    id: "flightToLocation",
    inputName: "arrive",
    label: "Enter Destination",
    placeholder: "Enter Destination",
    useResponseValues: true,
    filterMismatchingValues: true,
    airports: true,
    extraClass: modules_c6e28c37.destSearchInput
  })), /*#__PURE__*/React__default["default"].createElement(Grid.GridColumn, {
    columnS: "6",
    columnM: "5"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_c6e28c37.DateAndTime
  }, /*#__PURE__*/React__default["default"].createElement(DatePicker.DatePicker, {
    extraClass: modules_c6e28c37.Date,
    inputID: "bwFlightCheckin",
    inputName: "checkin",
    label: "Depart"
  }), formState != "oneway" ? /*#__PURE__*/React__default["default"].createElement(DatePicker.DatePicker, {
    extraClass: modules_c6e28c37.Date,
    inputID: "bwFlightCheckout",
    inputName: "checkout",
    label: "Return",
    plusDays: 2
  }) : /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_c6e28c37.ReturnDateHolder
  }))), /*#__PURE__*/React__default["default"].createElement(Grid.GridColumn, {
    columnS: "6",
    columnM: "3"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_c6e28c37.passengers
  }, /*#__PURE__*/React__default["default"].createElement(Select.Select, {
    extraClass: modules_c6e28c37.Select,
    id: "flightAdultsSelect",
    label: "Adults",
    name: "adults"
  }, /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "1",
    value: "1"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "2",
    value: "2"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "3",
    value: "3"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "4",
    value: "4"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "5",
    value: "5"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "6",
    value: "6"
  })), /*#__PURE__*/React__default["default"].createElement(Select.Select, {
    extraClass: modules_c6e28c37.Select,
    id: "flightChildrenSelect",
    label: "Children",
    name: "children"
  }, /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "0",
    value: "0"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "1",
    value: "1"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "2",
    value: "2"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "3",
    value: "3"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "4",
    value: "4"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "5",
    value: "5"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "6",
    value: "6"
  })))), /*#__PURE__*/React__default["default"].createElement(Grid.GridColumn, {
    columnS: "6",
    columnM: "4"
  }, /*#__PURE__*/React__default["default"].createElement(Select.Select, {
    extraClass: modules_c6e28c37.SelectAuto,
    id: "flightRoomsSelect",
    label: "Preferred seating",
    name: "cabin"
  }, /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "All Classes of Service",
    value: "All"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "All Classes (Excluding Basic Economy)",
    value: "ExcludeBasicEconomy"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "Economy",
    value: "Economy"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "Business",
    value: "Business"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "First",
    value: "First"
  }))), /*#__PURE__*/React__default["default"].createElement(Grid.GridColumn, {
    alignHorizontal: "center"
  }, /*#__PURE__*/React__default["default"].createElement(Button.Button, {
    extraClass: modules_c6e28c37.SubmitBtn,
    label: "Search Flights",
    style: "NEU_PRIMARY",
    type: "button",
    ariaLabel: "",
    action: function action(e) {
      // If we have a flight search action
      if (flightSearchAction) {
        // https://stackoverflow.com/questions/27746304/how-to-check-if-an-object-is-a-promise
        Promise.resolve(flightSearchAction(e)).then(function () {
          // Make sure we have valid values and submit our form
          if (e && e.target && e.target.closest("form")) {
            e.target.closest("form").submit();
          }
        });
      } else {
        // Make sure we have valid values and submit our form
        if (e && e.target && e.target.closest("form")) {
          e.target.closest("form").submit();
        }
      }
    }
  }))))));
};
var FlightSearchPropTypes = {
  flightSearchAction: index.propTypes.exports.func,
  chainCode: index.propTypes.exports.string,
  clubCode: index.propTypes.exports.string
};
FlightSearch.propTypes = FlightSearchPropTypes;

var css$1 = ".CruiseSearch_module_visuallyHidden__3e36ec42 {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n.CruiseSearch_module_youtubeVideo__3e36ec42 {\n  width: 100%;\n  height: auto;\n  aspect-ratio: 16/9;\n  display: block;\n}\n\n.CruiseSearch_module_Form__3e36ec42 {\n  display: flex;\n  align-items: flex-start;\n  flex-wrap: wrap;\n}\n\n.CruiseSearch_module_Date__3e36ec42 {\n  margin-right: 24px;\n}\n\n.CruiseSearch_module_Select__3e36ec42 {\n  width: 100%;\n  min-width: 160px;\n  max-width: none;\n  margin-right: 24px;\n}\n@media (max-width: 768px) {\n  .CruiseSearch_module_Select__3e36ec42 {\n    margin-right: 0;\n    max-width: none;\n  }\n}\n\n.CruiseSearch_module_SelectAuto__3e36ec42 {\n  margin-right: 24px;\n  max-width: fit-content;\n}\n@media (max-width: 768px) {\n  .CruiseSearch_module_SelectAuto__3e36ec42 {\n    margin-right: 0;\n    max-width: none;\n  }\n}\n\n.CruiseSearch_module_SubmitBtn__3e36ec42 {\n  height: 88px;\n  min-width: 200px;\n}";
injectGlobalCss.injectCss(css$1, "/opt/atlassian/pipelines/agent/build/src/stories/components/AAA/BookingWidget/Cruise/CruiseSearch.module.scss");
var modules_f21b3241 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1080px)","uiBreakWideScreenMin":"strip-units(1920px)","visuallyHidden":"CruiseSearch_module_visuallyHidden__3e36ec42","youtubeVideo":"CruiseSearch_module_youtubeVideo__3e36ec42","Form":"CruiseSearch_module_Form__3e36ec42","Date":"CruiseSearch_module_Date__3e36ec42","Select":"CruiseSearch_module_Select__3e36ec42","SelectAuto":"CruiseSearch_module_SelectAuto__3e36ec42","SubmitBtn":"CruiseSearch_module_SubmitBtn__3e36ec42"};

function CruiseSearch(_ref) {
  var clubCode = _ref.clubCode,
    cruiseSearchAction = _ref.cruiseSearchAction,
    chainCode = _ref.chainCode;
  var _useState = React.useState("Ocean"),
    _useState2 = _rollupPluginBabelHelpers._slicedToArray(_useState, 2),
    cruiseTypes = _useState2[0],
    setCruiseType = _useState2[1];
  var _useState3 = React.useState(),
    _useState4 = _rollupPluginBabelHelpers._slicedToArray(_useState3, 2),
    length = _useState4[0],
    setCruiseLength = _useState4[1];
  var _useState5 = React.useState(),
    _useState6 = _rollupPluginBabelHelpers._slicedToArray(_useState5, 2),
    lines = _useState6[0],
    setCruiseLines = _useState6[1];
  var _useState7 = React.useState(),
    _useState8 = _rollupPluginBabelHelpers._slicedToArray(_useState7, 2),
    ships = _useState8[0],
    setCruiseShips = _useState8[1];
  var _useState9 = React.useState(),
    _useState10 = _rollupPluginBabelHelpers._slicedToArray(_useState9, 2),
    dates = _useState10[0],
    setCruiseDates = _useState10[1];
  var _useState11 = React.useState(),
    _useState12 = _rollupPluginBabelHelpers._slicedToArray(_useState11, 2),
    daysMin = _useState12[0],
    setDaysMin = _useState12[1];
  var _useState13 = React.useState(),
    _useState14 = _rollupPluginBabelHelpers._slicedToArray(_useState13, 2),
    daysMax = _useState14[0],
    setDaysMax = _useState14[1];
  var _useState15 = React.useState(),
    _useState16 = _rollupPluginBabelHelpers._slicedToArray(_useState15, 2),
    destinations = _useState16[0],
    setCruiseDestinations = _useState16[1];
  var loadCruiseOptions = /*#__PURE__*/function () {
    var _ref2 = _rollupPluginBabelHelpers._asyncToGenerator( /*#__PURE__*/_rollupPluginBabelHelpers._regeneratorRuntime().mark(function _callee() {
      var clubDomain, domain, response, cruiseLength, cruiseLines, cruiseShips, cruiseDates, cruiseDestinations;
      return _rollupPluginBabelHelpers._regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch("https://www.aaa.com/sharedservices/getota.jsp?club=014&ident=CCD");
          case 2:
            _context.next = 4;
            return _context.sent.text();
          case 4:
            clubDomain = _context.sent;
            domain = clubDomain.split(/\|/);
            _context.next = 8;
            return fetch("https://" + domain[3] + "/cruise/filters.json?final=true&cruiseType=" + cruiseTypes);
          case 8:
            _context.next = 10;
            return _context.sent.json();
          case 10:
            response = _context.sent;
            cruiseLength = response.fullDays.map(function (item) {
              return Object.keys(item).map(function (key, i) {
                return /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
                  key: i,
                  name: item[key],
                  value: key
                });
              });
            });
            setCruiseLength(cruiseLength);
            cruiseLines = response.cruiseLine.map(function (item) {
              return Object.keys(item).map(function (key, i) {
                return /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
                  key: i,
                  name: item[key],
                  value: key
                });
              });
            });
            setCruiseLines(cruiseLines);
            cruiseShips = response.ship.map(function (item) {
              return Object.keys(item).map(function (key, i) {
                return /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
                  key: i,
                  name: item[key],
                  value: key
                });
              });
            });
            setCruiseShips(cruiseShips);
            cruiseDates = response.departureMonth.map(function (item) {
              return Object.keys(item).map(function (key, i) {
                return /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
                  key: i,
                  name: item[key],
                  value: key
                });
              });
            });
            setCruiseDates(cruiseDates);
            cruiseDestinations = response.destination.map(function (item) {
              return Object.keys(item).map(function (key, i) {
                return /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
                  key: i,
                  name: item[key],
                  value: key
                });
              });
            });
            setCruiseDestinations(cruiseDestinations);
          case 21:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function loadCruiseOptions() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleChange = function handleChange(e) {
    var cruiseTypeSelection = e.target.value;
    setCruiseType(cruiseTypeSelection);
    loadCruiseOptions();
  };
  React.useEffect(function () {
    loadCruiseOptions();
  }, [cruiseTypes]);
  return /*#__PURE__*/React__default["default"].createElement(Grid.GridContainer, {
    width: "980"
  }, /*#__PURE__*/React__default["default"].createElement(Grid.GridColumn, {
    columnS: "12"
  }, /*#__PURE__*/React__default["default"].createElement(Typography.Header2, {
    serif: true,
    bold: true,
    centerText: true
  }, "AAA Cruise Search")), /*#__PURE__*/React__default["default"].createElement(Grid.GridColumn, {
    columnS: "12"
  }, /*#__PURE__*/React__default["default"].createElement(Form.Form, {
    extraClass: modules_f21b3241.Form,
    formAction: "https://www.aaa.com/sharedservices/booktravel.jsp?"
  }, /*#__PURE__*/React__default["default"].createElement(BookingWidgetExtraParameters, null), /*#__PURE__*/React__default["default"].createElement("input", {
    type: "hidden",
    name: "daysmin",
    value: daysMin
  }), /*#__PURE__*/React__default["default"].createElement("input", {
    type: "hidden",
    name: "daysmax",
    value: daysMax
  }), /*#__PURE__*/React__default["default"].createElement("input", {
    type: "hidden",
    name: "book",
    value: "cruise"
  }), clubCode != null && clubCode.trim().length > 0 ? /*#__PURE__*/React__default["default"].createElement("input", {
    type: "hidden",
    name: "club",
    value: clubCode
  }) : /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null), chainCode != null && chainCode.trim().length > 0 ? /*#__PURE__*/React__default["default"].createElement("input", {
    type: "hidden",
    name: "chaincode",
    value: chainCode
  }) : /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null), /*#__PURE__*/React__default["default"].createElement(Grid.GridContainer, {
    columnS: "4",
    width: "1440",
    gap: "noRowGap"
  }, /*#__PURE__*/React__default["default"].createElement(Grid.GridColumn, {
    columnS: "4"
  }, /*#__PURE__*/React__default["default"].createElement(Select.Select, {
    extraClass: modules_f21b3241.Select,
    id: "cruisetype",
    label: "Cruise type",
    name: "cruisetype",
    onChange: handleChange
  }, /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "Ocean Cruises",
    value: "Ocean"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "River Cruises",
    value: "River"
  }), /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "Cruise Tours",
    value: "Tour"
  }))), /*#__PURE__*/React__default["default"].createElement(Grid.GridColumn, {
    columnS: "4"
  }, /*#__PURE__*/React__default["default"].createElement(Select.Select, {
    extraClass: modules_f21b3241.Select,
    id: "anyDestinationSelect",
    label: "Destination",
    name: "destination"
  }, /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "Any Destination",
    value: ""
  }), destinations)), /*#__PURE__*/React__default["default"].createElement(Grid.GridColumn, {
    columnS: "4"
  }, /*#__PURE__*/React__default["default"].createElement(Select.Select, {
    extraClass: modules_f21b3241.Select,
    id: "cruiseDateSelect",
    label: "Cruise Date",
    name: "departuredate"
  }, /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "Any Month",
    value: ""
  }), dates)), /*#__PURE__*/React__default["default"].createElement(Grid.GridColumn, {
    columnS: "4"
  }, /*#__PURE__*/React__default["default"].createElement(Select.Select, {
    extraClass: modules_f21b3241.Select,
    id: "vendor",
    label: "Cruise Line",
    name: "vendor"
  }, /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "Any Cruise Line",
    value: ""
  }), lines)), /*#__PURE__*/React__default["default"].createElement(Grid.GridColumn, {
    columnS: "4"
  }, /*#__PURE__*/React__default["default"].createElement(Select.Select, {
    extraClass: modules_f21b3241.Select,
    id: "cruiseLength",
    label: "Cruise Length",
    name: "cruiseLength",
    onChange: function onChange(e) {
      // If we don't have a valid value
      // Set the values to be blank
      if (e == null || e.target == null || e.target.value == null || e.target.value.split("_").length != 2) {
        setDaysMax("");
        setDaysMin("");
      } else {
        // Set the min and max
        setDaysMin(e.target.value.split("_")[0]);
        setDaysMax(e.target.value.split("_")[1]);
      }
    }
  }, /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "Any Length",
    value: ""
  }), length)), /*#__PURE__*/React__default["default"].createElement(Grid.GridColumn, {
    columnS: "4"
  }, /*#__PURE__*/React__default["default"].createElement(Select.Select, {
    extraClass: modules_f21b3241.Select,
    id: "anyShipSelect",
    label: "Cruise Ship",
    name: "cruiseship"
  }, /*#__PURE__*/React__default["default"].createElement(selectOption.SelectOption, {
    name: "Any Cruise Ship",
    value: ""
  }), ships)), /*#__PURE__*/React__default["default"].createElement(Grid.GridColumn, {
    alignHorizontal: "center"
  }, /*#__PURE__*/React__default["default"].createElement(Button.Button, {
    extraClass: modules_f21b3241.SubmitBtn,
    label: "Search Cruises",
    style: "NEU_PRIMARY",
    type: "button",
    ariaLabel: "",
    action: function action(e) {
      // If we have a cruise search action
      if (cruiseSearchAction) {
        // Try to resolve the result of the cruiseSearchAction as a promise
        // If it's a promise, it'll wait
        // otherwise, it'll execute immediately
        // https://stackoverflow.com/questions/27746304/how-to-check-if-an-object-is-a-promise
        Promise.resolve(cruiseSearchAction(e)).then(function () {
          // Make sure we have valid values and submit our form
          if (e && e.target && e.target.closest("form")) {
            e.target.closest("form").submit();
          }
        });
      } else {
        // Make sure we have valid values and submit our form
        if (e && e.target && e.target.closest("form")) {
          e.target.closest("form").submit();
        }
      }
    }
  }))))));
}
CruiseSearch.propTypes = {
  cruiseSearchAction: index.propTypes.exports.func,
  chainCode: index.propTypes.exports.string,
  clubCode: index.propTypes.exports.string
};

var css = ".BookingWidget_module_visuallyHidden__069d921b {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n.BookingWidget_module_youtubeVideo__069d921b {\n  width: 100%;\n  height: auto;\n  aspect-ratio: 16/9;\n  display: block;\n}";
injectGlobalCss.injectCss(css, "/opt/atlassian/pipelines/agent/build/src/stories/components/AAA/BookingWidget/BookingWidget.module.scss");
var modules_949386a8 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1080px)","uiBreakWideScreenMin":"strip-units(1920px)","visuallyHidden":"BookingWidget_module_visuallyHidden__069d921b","youtubeVideo":"BookingWidget_module_youtubeVideo__069d921b"};

var BookingWidget = function BookingWidget(_ref) {
  var _ref$hideHotel = _ref.hideHotel,
    hideHotel = _ref$hideHotel === void 0 ? false : _ref$hideHotel,
    _ref$hideCar = _ref.hideCar,
    hideCar = _ref$hideCar === void 0 ? false : _ref$hideCar,
    _ref$hideFlight = _ref.hideFlight,
    hideFlight = _ref$hideFlight === void 0 ? false : _ref$hideFlight,
    _ref$hideCruise = _ref.hideCruise,
    hideCruise = _ref$hideCruise === void 0 ? false : _ref$hideCruise,
    _ref$defaultActive = _ref.defaultActive,
    defaultActive = _ref$defaultActive === void 0 ? 0 : _ref$defaultActive,
    chainCode = _ref.chainCode,
    clubCode = _ref.clubCode,
    tabOnClick = _ref.tabOnClick,
    hotelSearchAction = _ref.hotelSearchAction,
    flightSearchAction = _ref.flightSearchAction,
    carSearchAction = _ref.carSearchAction,
    cruiseSearchAction = _ref.cruiseSearchAction,
    preFillCarInputPromoNumber = _ref.preFillCarInputPromoNumber;
  var _useState = React.useState(hideHotel),
    _useState2 = _rollupPluginBabelHelpers._slicedToArray(_useState, 2),
    hotel = _useState2[0];
    _useState2[1];
  var _useState3 = React.useState(hideCar),
    _useState4 = _rollupPluginBabelHelpers._slicedToArray(_useState3, 2),
    car = _useState4[0];
    _useState4[1];
  var _useState5 = React.useState(hideFlight),
    _useState6 = _rollupPluginBabelHelpers._slicedToArray(_useState5, 2),
    flight = _useState6[0];
    _useState6[1];
  var _useState7 = React.useState(hideCruise),
    _useState8 = _rollupPluginBabelHelpers._slicedToArray(_useState7, 2),
    cruise = _useState8[0];
    _useState8[1];
  React.useEffect(function () {}, [hotel, car, flight, cruise]);
  return /*#__PURE__*/React__default["default"].createElement(Containers.Container, {
    width: "1366",
    noPadding: true
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_949386a8.BookingWidget
  }, /*#__PURE__*/React__default["default"].createElement(SubTabs.SubTabs, {
    defaultActive: defaultActive,
    tabOnClick: tabOnClick,
    tabsItems: [{
      content: /*#__PURE__*/React__default["default"].createElement(HotelSearch, {
        clubCode: clubCode,
        chainCode: chainCode,
        hotelSearchAction: hotelSearchAction
      }),
      id: 0,
      label: 'Hotels',
      hideTab: hotel
    }, {
      content: /*#__PURE__*/React__default["default"].createElement(FlightSearch, {
        clubCode: clubCode,
        chainCode: chainCode,
        flightSearchAction: flightSearchAction
      }),
      id: 1,
      label: 'Flights',
      hideTab: flight
    }, {
      content: /*#__PURE__*/React__default["default"].createElement(CarSearch, {
        clubCode: clubCode,
        chainCode: chainCode,
        carSearchAction: carSearchAction,
        preFillCarInputPromoNumber: preFillCarInputPromoNumber
      }),
      id: 2,
      label: 'Cars',
      hideTab: car
    }, {
      content: /*#__PURE__*/React__default["default"].createElement(CruiseSearch, {
        clubCode: clubCode,
        chainCode: chainCode,
        cruiseSearchAction: cruiseSearchAction
      }),
      id: 3,
      label: 'Cruises',
      hideTab: cruise
    }]
  })));
};
var BookingWidgetPropTypes = {
  hideHotel: index.propTypes.exports.bool,
  hideCar: index.propTypes.exports.bool,
  hideFlight: index.propTypes.exports.bool,
  hideCruise: index.propTypes.exports.bool,
  defaultActive: index.propTypes.exports.number,
  tabOnClick: index.propTypes.exports.func,
  clubCode: index.propTypes.exports.string,
  hotelSearchAction: index.propTypes.exports.func,
  flightSearchAction: index.propTypes.exports.func,
  carSearchAction: index.propTypes.exports.func,
  cruiseSearchAction: index.propTypes.exports.func,
  chainCode: index.propTypes.exports.string,
  preFillCarInputPromoNumber: index.propTypes.exports.string
};
BookingWidget.propTypes = BookingWidgetPropTypes;

exports.BookingWidget = BookingWidget;
